const OtherVitalInfo = () => {
    return (
        <div id="other" className="vision-card">
            <h3>OTHER VITAL INFORMATION</h3>

                <div className="table-section-wrap">
                    <table className="table-section">
                        <tbody>

                            <tr>
                                <td>NAME OF THE SCHOOL</td>
                                <td>NAVJEEVAN MISSION SCHOOL</td>
                                <td>AFFILIATION NO. (IF APPLICABLE)</td>
                                <td>2132348</td>
                            </tr>

                            <tr>
                                <td>SCHOOL CODE (IF APPLICABLE)</td>
                                <td>71065</td>
                                <td>COMPLETE ADDRESS WITH PIN CODE</td>
                                <td>Sonauli Road, Anandnagar Maharajganj PIN-273155</td>
                            </tr>

                            <tr>
                                <td>PRINCIPAL NAME & QUALIFICATION</td>
                                <td>SHAJI LOUIS</td>
                                <td>SCHOOL EMAIL ID</td>
                                <td>navjeevananandnagar@gmail.com</td>
                            </tr>

                            <tr>
                                <td>CONTACT DETAILS (LANDLINE/MOBILE)</td>
                                <td>7525013411</td>
                                <td>COPIES OF AFFILIATION / UPGRADATION LETTER AND RECENT EXTENSION OF AFFILIATION,IF ANY</td>
                                <td></td>
                            </tr>

                            <tr>
                                <td>COPIES OF SOCIETIES/TRUST/COMPANY REGISTRATION/RENEWAL CERTIFICATE,AS APPLICABLE</td>
                                <td></td>
                                <td>COPY OF NO OBJECTION CERTIFICATE (NOC)  ISSUED,IF APPLICABLE,BY THE STATE GOVT./UT</td>
                                <td></td>
                            </tr>

                            <tr>
                                <td>COPIES OF RECOGNITION CERTIFICATE UNDER RTE ACT, 2009 AND IT'S RENEWAL IF APPLICABLE</td>
                                <td></td>
                                <td>COPY OF VALID BUILDING SAFETY CERTIFICATE AS PER THE NATIONAL BUILDING CODE</td>
                                <td></td>
                            </tr>

                            <tr>
                                <td>COPY OF VALID FIRE SAFETY CERTIFICATE ISSUED BY THE COMPETENT AUTHORITY</td>
                                <td>0</td>
                                <td>COPY OF THE DEO CERTIFICATE SUBMITTED BY THE SCHOOL FOR AFFILIATION/UPGRADATION/EXTENSION OF AFFILIATION SELF CERTIFICATION BY SCHOOL</td>
                                <td>0</td>
                            </tr>


                            <tr>
                                <td>COPIES OF VALID WATER, HEALTH AND SANITATION CERTIFICATES</td>
                                <td>0</td>
                                <td>FEE STRUCTURE OF THE SCHOOL</td>
                                <td></td>
                            </tr>

                            <tr>
                                <td>ANNUAL ACADEMIC CALANDER</td>
                                <td></td>
                                <td>LIST OF SCHOOL MANAGEMENT COMMITTEE (SMC)</td>
                                <td></td>
                            </tr>

                            <tr>
                                <td>LIST OF PARENTS TEACHERS ASSOCIATION (PTA) MEMBERS</td>
                                <td></td>
                                <td>LAST THREE-YEAR RESULT OF THE BOARD EXAMINATION AS PER APPLICABILITY</td>
                                <td></td>
                            </tr>

                            <tr>
                                <td>RESULT OF CLASS 10 BOARD S.NO./YEAR/REGISTERED STUDENTS/PASSED STUDENT NO./PASS PERCENTAGE</td>
                                <td>1/2018-19/129/126/97.80 % 2/2019-20/155/150/96.80 %</td>
                                <td>NAME OF BANK WITH SALARY ACCOUNT</td>
                                <td>State Bank Of India Anandnagar</td>
                            </tr>

                            <tr>
                                <td>RESULT OF CLASS 12 BOARD S.NO./YEAR/REGISTERED STUDENTS/PASSED STUDENT NO./PASS PERCENTAGE</td>
                                <td>NIL</td>
                                <td>NAME OF BANK WITH SALARY ACCOUNT</td>
                                <td>State Bank Of India Anandnagar</td>
                            </tr>


                            <tr>
                                <td>TOTAL CAMPUS AREA OF THE SCHOOL (IN SQUARE MTR)</td>
                                <td>8100</td>
                                <td>NO. AND SIZE OF THE CLASS ROOMS (IN SQ MTR)</td>
                                <td>46.45</td>
                            </tr>

                            <tr>
                                <td>NO. AND SIZE OF LABORATORIES INCLUDING COMPUTER</td>
                                <td>74.32</td>
                                <td>INTERNET FACILITY (Y/N)</td>
                                <td>Y</td>
                            </tr>

                            <tr>
                                <td>NO. OF GIRLS TOILETS</td>
                                <td>3</td>
                                <td>NO. OF BOYS TOILETS</td>
                                <td>3</td>
                            </tr>

                            <tr>
                                <td>LINK OF YOUTUBE VIDEO OF THE INSPECTION OF SCHOOL COVERING THE INFRASTRUCTURE OF THE SCHOOL</td>
                                <td>NJMS BE INSPIRED Y</td>
                                <td>TOTAL NO. OF TEACHERS</td>
                                <td>28</td>
                            </tr>

                            <tr>
                                <td>PGT TEACHERS</td>
                                <td>7</td>
                                <td>TGT TEACHERS</td>
                                <td>8</td>
                            </tr>

                            <tr>
                                <td>PRT TEACHERS</td>
                                <td>8</td>
                                <td>TEACHERS SECTION RATIO</td>
                                <td>1:5</td>
                            </tr>

                            <tr>
                                <td>DETAILS OF SPECIAL EDUCATOR B.SC/SPEC/BED</td>
                                <td>SHAIFY MP</td>
                                <td>DETAILS OF COUNSELLOR & WELLNESS TEACHER M.A/B.ED/PHY.COL</td>
                                <td>RUPAUYALI</td>
                            </tr>

                            <tr>
                                <td>ARE THE SCHOOL ACCOUNTS AUDITED REGULARLY ?</td>
                                <td>YES</td>
                                <td>PARENT TEACHERS ASSOCIATION AS PER NORMS</td>
                                <td>YES</td>
                            </tr>

                            <tr>
                                <td>ACADEMIC SESSION</td>
                                <td>APRIL TO MARCH</td>
                                <td>VACATION PERIOD</td>
                                <td>MAY TO JUNE</td>
                            </tr>

                            <tr>
                                <td>AUDITED BALANCE SHEET OF SCHOOL</td>
                                <td>VIEW (PdfHandler .aspx? FileName=G:\cbse\2016\schdetails\balance\55584.pdf )</td>
                                <td>STAFF STATEMENT OF SCHOOL</td>
                                <td>VIEW (PdfHandler .aspx? FileName=G:\cbse\2016\schdetails\sta#\55584.pdf )</td>
                            </tr>

                            <tr>
                                <td>INCOME AND EXPENDITURE STATEMENT</td>
                                <td>VIEW (PdfHandler .aspx? FileName=G:\cbse\2016\schdetails\income\55584.pdf )</td>
                                <td>ACADEMIC CALENDAR OF SCHOOL</td>
                                <td>VIEW (PdfHandler .aspx? FileName=G:\cbse\2016\schdetails\academic\55584.pdf )</td>
                            </tr>

                            <tr>
                                <td colSpan="4" style={{ textAlign: "center", fontWeight: "700" }}>
                                    BEST PRACTICES OF SCHOOL
                                </td>
                            </tr>

                            <tr>
                                <td colSpan="4">
                                    Maintains Perfect Disciplined and Spoken English Campus,
                                    Smart Class, Subject Teacher Meeting, Workshops for Teachers,
                                    Regular Analysis of Result, Motivation Classes, Active
                                    Participation in Swachha Bharat Abhiyan.
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            
        </div>
    );
};

export default OtherVitalInfo;